module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-regular.6a9e85ac.ttf";